import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { editionForBook } from '../utils/bibleEditions';
import { dailyVerseDate, selectDailyVerse, extractDailyVerse } from '../utils/dailyVerse';
import './DailyVerse.css';

export default function DailyVerse({ type }) {
  const [date, setDate] = useState(dailyVerseDate);
  const [result, setResult] = useState(null);
  const [retry, setRetry] = useState(0);
  const [book, name, englishName, chapter, verse] = selectDailyVerse(date);
  const edition = editionForBook(type, book) || 'norm';
  const key = `${date}:${edition}`;
  const english = type === 'en';
  const current = result?.key === key ? result : null;

  useEffect(() => {
    const update = () => setDate(dailyVerseDate());
    const timer = window.setInterval(update, 1000);
    document.addEventListener('visibilitychange', update);
    return () => {
      window.clearInterval(timer);
      document.removeEventListener('visibilitychange', update);
    };
  }, []);

  useEffect(() => {
    const controller = new AbortController();
    setResult(null);
    fetch(`${process.env.PUBLIC_URL}/static/html/${edition}/${book}.htm`, { signal: controller.signal })
      .then(response => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return response.text();
      })
      .then(html => {
        const text = extractDailyVerse(html, chapter, verse);
        if (!controller.signal.aborted) setResult({ key, text });
      })
      .catch(() => {
        if (!controller.signal.aborted) setResult({ key, error: true });
      });
    return () => controller.abort();
  }, [book, chapter, verse, edition, key, retry]);

  return (
    <section className="daily-verse" aria-labelledby="daily-verse-title">
      <div className="daily-verse__heading">
        <h2 id="daily-verse-title">{english ? 'Verse of the Day' : '本日のありがた〜いお言葉'}</h2>
        <time dateTime={date}>{date.replaceAll('-', '.')}</time>
      </div>
      <Link className="daily-verse__link" to={`/bible/${book}/${chapter}/${verse}?type=${edition}`}>
        <div aria-live="polite" aria-busy={!current}>
          {current?.text ? (
            <blockquote dir={edition === 'hebrew' ? 'rtl' : undefined}>{current.text}</blockquote>
          ) : (
            <p className="daily-verse__status">{current?.error
              ? (english ? 'Unable to load the verse.' : '聖句を読み込めませんでした。')
              : (english ? 'Loading…' : '聖句を読み込み中…')}</p>
          )}
        </div>
        <span className="daily-verse__reference">{english ? englishName : name} {chapter}:{verse}</span>
        <span className="daily-verse__more">{english ? 'Read this passage' : 'この箇所を読む'} <span aria-hidden="true">→</span></span>
      </Link>
      {current?.error && <button className="daily-verse__retry" onClick={() => setRetry(value => value + 1)}>{english ? 'Retry' : '再読み込み'}</button>}
    </section>
  );
}
